import request from '@/middleware/request'

const getListReport = () => {
  return request({
    url: '/report/list_report',
    method: 'get'
  })
}

const getListChannel = type => {
  return request({
    url: `/report/list_channel/${type}`,
    method: 'get'
  })
}

const getListServiceLogType = () => {
  return request({
    url: '/report/list_service_log_type',
    method: 'get'
  })
}

const getReport = (name, data) => {
  return request({
    url: `/report/view/${name}`,
    method: 'post',
    data
  })
}

const exportReport = (type, name, data) => {
  return request({
    url: `/report/export/${type}/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// Old apis

const getCampaign = data => {
  // Standard
  return request({
    url: '/report/campaign',
    method: 'post',
    data
  })
}
const getCustomerSatisfaction = data => {
  // Standard
  return request({
    url: '/report/customer_satisfaction',
    method: 'post',
    data
  })
}
const getFAQ = data => {
  // Standard
  return request({
    url: '/report/faq',
    method: 'post',
    data
  })
}
const getIntentSummary = data => {
  // Standard
  return request({
    url: '/report/intent_summary',
    method: 'post',
    data
  })
}
const getSelfServiceSummary = data => {
  // Standard
  return request({
    url: '/report/self_service_summary',
    method: 'post',
    data
  })
}
const getSessionDetail = data => {
  // Standard
  return request({
    url: '/report/session_detail',
    method: 'post',
    data
  })
}
const getSession = data => {
  // Standard
  return request({
    url: '/report/session',
    method: 'post',
    data
  })
}
const getTransfer = data => {
  // Standard
  return request({
    url: '/report/transfer',
    method: 'post',
    data
  })
}
const getService = data => {
  // Standard
  return request({
    url: '/report/service',
    method: 'post',
    data
  })
}
const getServiceByMonth = data => {
  // Standard
  return request({
    url: '/report/service_by_month',
    method: 'post',
    data
  })
}

const getCallBackDetail = data => {
  return request({
    url: '/report/call_back_detail',
    method: 'post',
    data
  })
}
const getCallBackSummaryByDate = data => {
  return request({
    url: '/report/call_back_summary_by_date',
    method: 'post',
    data
  })
}
const getCallBackSummaryByService = data => {
  return request({
    url: '/report/call_back_summary_by_service',
    method: 'post',
    data
  })
}
const getOverallVoiceBot = data => {
  return request({
    url: '/report/overall_voice_bot',
    method: 'post',
    data
  })
}
const getServiceSummary = data => {
  return request({
    url: '/report/service_summary',
    method: 'post',
    data
  })
}
const getSessionSummaryByDate = data => {
  return request({
    url: '/report/session_summary_by_date',
    method: 'post',
    data
  })
}
const getSessionSummaryByLastService = data => {
  return request({
    url: '/report/session_summary_by_last_service',
    method: 'post',
    data
  })
}

const getJourneylogRawData = data => {
  // Custom AIA *IB *OB
  return request({
    url: '/report/journeylog_raw_data',
    method: 'post',
    data
  })
}
const getOutboundPolicyDetails = data => {
  // Custom AIA
  return request({
    url: '/report/outbound_policy_details',
    method: 'post',
    data
  })
}
const getSelfServiceSummary1 = data => {
  // Custom AIA
  return request({
    url: '/report/self_service_summary1',
    method: 'post',
    data
  })
}

const getIntentionDetail = data => {
  // Custom Homepro
  return request({
    url: '/report/intention_detail',
    method: 'post',
    data
  })
}
const getIntentionMismatch = data => {
  // Custom Homepro
  return request({
    url: '/report/intention_mismatch',
    method: 'post',
    data
  })
}
const getIntentionSummary = data => {
  // Custom Homepro
  return request({
    url: '/report/intention_summary',
    method: 'post',
    data
  })
}

const getFAQ1 = data => {
  // Custom For QA
  return request({
    url: '/report/faq1',
    method: 'post',
    data
  })
}
const getTransferServiceDetail = data => {
  // Custom For QA
  return request({
    url: '/report/transfer_service_detail',
    method: 'post',
    data
  })
}
const getTransferService = data => {
  // Custom For QA
  return request({
    url: '/report/transfer_service',
    method: 'post',
    data
  })
}

const getGsbhdCallSuccessFailReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_call_success_fail_report',
    method: 'post',
    data
  })
}
const getGsbhdCallReceivedReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_call_received_report',
    method: 'post',
    data
  })
}
const getGsbhdServiceDeskReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_service_desk_report',
    method: 'post',
    data
  })
}
const getGsbhdSystemPerformanceReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_system_performance_report',
    method: 'post',
    data
  })
}
const getGsbhdImportDataReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_import_data_report',
    method: 'post',
    data
  })
}
const getGsbhdCustomerSatisfactionReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_customer_satisfaction_report',
    method: 'post',
    data
  })
}
const getGsbhdTransferReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_transfer_report',
    method: 'post',
    data
  })
}
const getGsbhdCallDurationReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_call_duration_report',
    method: 'post',
    data
  })
}
const getGsbhdServiceReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_service_report',
    method: 'post',
    data
  })
}
const getGsbhdDigitalVirtualAgentReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_digital_virtual_agent_report',
    method: 'post',
    data
  })
}
const getGsbhdUptimeReport = data => {
  // Custom For GSB Helpdesk
  return request({
    url: '/customize/gsbhd/reports/gsbhd_uptime_report',
    method: 'post',
    data
  })
}

const exportExcel = (name, data) => {
  return request({
    url: `/report/export/excel/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

const exportPdf = (name, data) => {
  return request({
    url: `/report/export/pdf/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

export default {
  getListReport,
  getListChannel,
  getListServiceLogType,
  getReport,
  exportReport,

  getCampaign, // Standard
  getCustomerSatisfaction, // Standard
  getFAQ, // Standard
  getIntentSummary, // Standard
  getSelfServiceSummary, // Standard
  getSessionDetail, // Standard
  getSession, // Standard
  getTransfer, // Standard
  getService, // Standard
  getServiceByMonth, // Standard

  getCallBackDetail,
  getCallBackSummaryByDate,
  getCallBackSummaryByService,
  getOverallVoiceBot,
  getServiceSummary,
  getSessionSummaryByDate,
  getSessionSummaryByLastService,

  getJourneylogRawData, // Custom AIA *IB *OB
  getOutboundPolicyDetails, // Custom AIA
  getSelfServiceSummary1, // Custom AIA

  getIntentionDetail, // Custom Homepro
  getIntentionMismatch, // Custom Homepro
  getIntentionSummary, // Custom Homepro

  getFAQ1,
  getTransferServiceDetail,
  getTransferService,

  getGsbhdCallSuccessFailReport, // Custom For GSB Helpdesk
  getGsbhdCallReceivedReport, // Custom For GSB Helpdesk
  getGsbhdServiceDeskReport, // Custom For GSB Helpdesk
  getGsbhdSystemPerformanceReport, // Custom For GSB Helpdesk
  getGsbhdImportDataReport, // Custom For GSB Helpdesk
  getGsbhdCustomerSatisfactionReport, // Custom For GSB Helpdesk
  getGsbhdTransferReport, // Custom For GSB Helpdesk
  getGsbhdCallDurationReport, // Custom For GSB Helpdesk
  getGsbhdServiceReport, // Custom For GSB Helpdesk
  getGsbhdDigitalVirtualAgentReport, // Custom For GSB Helpdesk
  getGsbhdUptimeReport, // Custom For GSB Helpdesk

  exportExcel,
  exportPdf
}
